var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 94,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.221 15.5H6A5.5 5.5 0 00.5 21v66.546a5.5 5.5 0 005.5 5.5h51a5.5 5.5 0 005.5-5.5V53.897a30.404 30.404 0 01-5 0v33.649a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5V21a.5.5 0 01.5-.5h24.202c.2-1.715.543-3.386 1.02-5zM12.636 51.318a2.5 2.5 0 012.5-2.5h20.728a2.5 2.5 0 010 5H15.136a2.5 2.5 0 01-2.5-2.5zm2.5 7.864a2.5 2.5 0 000 5h20.728a2.5 2.5 0 000-5H15.136zm-2.5 18.045a2.5 2.5 0 012.5-2.5h7.773a2.5 2.5 0 010 5h-7.773a2.5 2.5 0 01-2.5-2.5zM22.69 34a5.182 5.182 0 11-10.364 0 5.182 5.182 0 0110.364 0z",
    fill: "#695DE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.901 46.18c12.441 0 22.62-10.202 22.62-22.671 0-12.47-10.179-22.672-22.62-22.672-12.44 0-22.62 10.202-22.62 22.672S47.373 46.18 59.901 46.18zm0-40.634c9.831 0 17.922 8.022 17.922 17.963 0 9.853-8.09 17.963-17.922 17.963-9.918 0-17.922-8.022-17.922-17.963 0-9.94 8.004-17.963 17.922-17.963z",
    fill: "#3AD08F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.813 30.049a2.374 2.374 0 001.654.697c.608 0 1.218-.261 1.653-.697l9.83-9.854c.957-.96.957-2.442 0-3.314-.957-.959-2.436-.959-3.306 0l-8.178 8.197-3.306-3.313c-.956-.96-2.435-.96-3.305 0-.957.959-.957 2.441 0 3.313l4.959 4.97z",
    fill: "#3AD08F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.ec60eab6abc2100df05b28a677325b54.svg";
export { ForwardRef as ReactComponent };